import { get } from "@/utils/requestUtil";

export function getSupplierSetting(supplierId) {
  return get(`/o2oms/merchant/v1/c/supplier_setting/${supplierId}`);
}
